export default {
  'global.no.conection.message': 'Please make sure to turn on Wi-Fi or mobile data, then try again',
  'global.no.conection.title': 'No internet connection',
  'global.no.error.title': 'Error',
  'global.button.close': 'Close',
};
